module.exports = "div.collapsed {\n    overflow: hidden;\n}\n\na {\n    color: #0275d8!important;\n}\n\na:hover {\n    cursor: pointer!important;\n    text-decoration: underline!important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/mostrar-mas/mostrar-mas.component.css
// module id = ./src/app/ui/mostrar-mas/mostrar-mas.component.css
// module chunks = main